export default "__VITE_ASSET__5455c46b__"